import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { createApiSlice } from "@common/common-slice/commonSlice";

import { timeoutCall } from "@common";

import { downloadExcelFile } from "@helper";

import {
  CREATE_COMPETECY_FRAMEWORK_PREDEFINED,
  CRUD_COMPETENCY_FRAMEWORK,
  DOWNLOAD_COMPETENCY_FRAMEWORK,
  FETCH_PROJECT_BY_ACCOUNT,
  FORCE_DELETE_COMPETENCY_FRAMEWORK_PROJECT_LEVEL,
  GET_ALL_LEVEL_PUBLISHED_COMPETENCY_FRAMEWORK,
  GET_ARCHIVED_COMPETENCY_FRAMEWORK,
  GET_COMP_FRAMEWORK_BY_ACCONUT_ID,
  GET_COMP_FRAMEWORK_BY_PROJECT_ID,
  GET_COMPETENCY_FRAMEWORK_DETAILS,
  GET_COMPETENCY_FRAMEWORK_DETAILS_SETUP,
  GET_COMPETENCY_FRMEWORKL_STATUS_HISTORY,
  GET_COMPETENCY_FRMEWORKL_STATUS_HISTORY_SETUP,
  GET_PUBLISHED_COMPETENCY_FRAMEWORK_SETUP,
  UPLOAD_COMPETENCY_FRAMEWORK,

  // setup routes
  CRUD_COMPETENCY_FRAMEWORK_CONFIG,
} from "@routes";

const apiConfig = [
  {
    name: "createCompetencyFrameworkPredefined",
    method: "post",
    url: CREATE_COMPETECY_FRAMEWORK_PREDEFINED,
    stateKey: "message",
  },
  {
    name: "createCompetencyFramework",
    method: "post",
    url: CRUD_COMPETENCY_FRAMEWORK,
    stateKey: "message",
  },
  {
    name: "getCompetencyFramework",
    method: "get",
    url: CRUD_COMPETENCY_FRAMEWORK,
    stateKey: "competencyFrameworkApplicationLevelData",
  },
  {
    name: "getCalibratedArchivedCompetencyFramework",
    method: "get",
    url: GET_ARCHIVED_COMPETENCY_FRAMEWORK,
    stateKey: "competencyFrameworkApplicationLevelData",
  },
  {
    name: "getPublishedCompetencyFramework",
    method: "get",
    url: CRUD_COMPETENCY_FRAMEWORK,
    stateKey: "competencyFrameworkData",
  },
  {
    name: "getProjectByAccount",
    method: "get",
    url: FETCH_PROJECT_BY_ACCOUNT,
    stateKey: "projectData",
  },
  {
    name: "getArchivedCompetencyFramework",
    method: "get",
    url: GET_ARCHIVED_COMPETENCY_FRAMEWORK,
    stateKey: "competencyFrameworkData",
  },
  {
    name: "getCompetencyFrameworkStatusHistory",
    method: "get",
    url: GET_COMPETENCY_FRMEWORKL_STATUS_HISTORY,
    stateKey: "statusHistoryData",
  },
  {
    name: "getAllLevelPublishedCompetencyFramework",
    method: "get",
    url: GET_ALL_LEVEL_PUBLISHED_COMPETENCY_FRAMEWORK,
    stateKey: "competencyFrameworkData",
  },
  {
    name: "getCompetencyFrameworkById",
    method: "get",
    url: GET_COMP_FRAMEWORK_BY_ACCONUT_ID,
    stateKey: "competencyFrameworkData",
  },
  {
    name: "getCompetencyFrameworkByProjectId",
    method: "get",
    url: GET_COMP_FRAMEWORK_BY_PROJECT_ID,
    stateKey: "competencyFrameworkData",
  },
  {
    name: "getCompetencyFrameworkDetails",
    method: "get",
    url: GET_COMPETENCY_FRAMEWORK_DETAILS,
    stateKey: "details",
  },
  {
    name: "archiveAndUnarchiveFramework",
    method: "put",
    url: GET_ARCHIVED_COMPETENCY_FRAMEWORK,
    stateKey: "message",
  },
  {
    name: "updateCompetencyFramework",
    method: "put",
    url: CRUD_COMPETENCY_FRAMEWORK,
    stateKey: "message",
  },
  {
    name: "updateStatusCompetencyFramework",
    method: "patch",
    url: CRUD_COMPETENCY_FRAMEWORK,
    stateKey: "message",
  },
  {
    name: "forceDeleteCompetencyFramework",
    method: "delete",
    url: FORCE_DELETE_COMPETENCY_FRAMEWORK_PROJECT_LEVEL,
    stateKey: "message",
  },


  // config API's
  {
    name: "createCompetencyFrameworkConfig",
    method: "post",
    url: CRUD_COMPETENCY_FRAMEWORK_CONFIG,
    stateKey: "message",
  },
  {
    name: "getCompetencyFrameworkConfig",
    method: "get",
    url: CRUD_COMPETENCY_FRAMEWORK_CONFIG,
    stateKey: "competencyFrameworkData",
  },
  {
    name: "getPublishedCompetencyFrameworkSetup",
    method: "get",
    url: GET_PUBLISHED_COMPETENCY_FRAMEWORK_SETUP,
    stateKey: "competencyFrameworkSetupData",
  },
  {
    name: "getCompetencyFrameworkDetailsSetup",
    method: "get",
    url: GET_COMPETENCY_FRAMEWORK_DETAILS_SETUP,
    stateKey: "detailsSetup",
  },
  {
    name: "getCompetencyFrameworkStatusHistorySetup",
    method: "get",
    url: GET_COMPETENCY_FRMEWORKL_STATUS_HISTORY_SETUP,
    stateKey: "statusHistoryDataSetup",
  },  
  {
    name: "updateCompetencyFrameworkConfig",
    method: "put",
    url: CRUD_COMPETENCY_FRAMEWORK_CONFIG,
    stateKey: "message",
  },
  {
    name: "updateCompetencyFrameworkStatusConfig",
    method: "patch",
    url: CRUD_COMPETENCY_FRAMEWORK_CONFIG,
    stateKey: "message",
  },
  {
    name: "deleteCompetencyFrameworkConfig",
    method: "delete",
    url: CRUD_COMPETENCY_FRAMEWORK_CONFIG,
    stateKey: "message",
  },
];
// ---------------------------------------------------------------------
// Upload Competency Framework
// ---------------------------------------------------------------------

export const uploadCompetencyFramework =
  createAsyncThunk("competencyFramework/uploadCompetencyFramework",
    async (data,{ rejectWithValue, dispatch },
    ) => {
      try {
        const response =
          await axios.post(
            UPLOAD_COMPETENCY_FRAMEWORK,
            data,
            {
              withCredentials: true,
            },
          );
        resetFunction(dispatch);
        return response;
      } catch (err) {
        resetFunction(dispatch);
        return rejectWithValue(
          err.response.data,
        );
      }
    },
  );

// ---------------------------------------------------------------------
// Download Competency Framework
// ---------------------------------------------------------------------

export const downloadCompetencyFramework =
  createAsyncThunk("competencyFramework/downloadCompetencyFramework",
    async (
      data,
      { rejectWithValue, dispatch },
    ) => {
  return downloadExcelFile({
        url: DOWNLOAD_COMPETENCY_FRAMEWORK,
        params: data,
        fileName: "CompetencyFramework.xlsx",
        dispatch,
        rejectWithValue,
        resetFunction,
      });
    }
  );

  const customReducers = {
  initialState: {
    competencyFrameworkData: [],
    allCompetencyFrameworkData: [],   // source of truth from API
    statusHistoryData: [],
    statusHistoryDataSetup: [],
    projectData: [],
    details: [],
    competencyFrameworkApplicationLevelData: [],
    detailsSetup: [],
    competencyFrameworkSetupData: [],
    searchCompetencyData: "",
    selectedData: {},
    selectedAccountData: null,
    selectedProjectData: null,
  },

  reducers: {
    selectAccountData: (state, action) => {
      state.selectedAccountData = action?.payload;
    },
    selectProjectData: (state, action) => {
      state.selectedProjectData = action?.payload;
    },
    setAllCompetencyFramework: (state, action) => {
      state.allCompetencyFrameworkData = action?.payload;
      state.competencyFrameworkData = action?.payload;
    },
    setCompetencyFramework: (state, action) => {
      state.competencyFrameworkData = action?.payload;
    },  
    setCompetencySearchTerm: (state, action) => {
      state.searchCompetencyData = action?.payload;
    },
  },
  extraReducers: {
    // -------------------------------------------------------------
    // Upload Competency Framework
    // -------------------------------------------------------------

    "assessmentTemplate/uploadCompetencyFramework/pending": (state) => {
      state.loading = true;
    },

    "assessmentTemplate/uploadCompetencyFramework/fulfilled": (state, action) => {
      state.loading = false;

      state.message = action?.payload?.data?.message;
    },

    "assessmentTemplate/uploadCompetencyFramework/rejected": (state, action) => {
      state.loading = false;

      state.errMessage = action?.payload?.message;
    },

    // -------------------------------------------------------------
    // Download Competency Framework
    // -------------------------------------------------------------

    "assessmentTemplate/downloadCompetencyFramework/pending": (state) => {
      state.loading = true;
    },

    "assessmentTemplate/downloadCompetencyFramework/fulfilled": (state) => {
      state.loading = false;
    },

    "assessmentTemplate/downloadCompetencyFramework/rejected": (state, action) => {
      state.loading = false;

      state.errMessage = action?.payload?.data?.message;
    },
  },
};

const { slice, thunks, actions } = createApiSlice(
  "competencyFramework",
  apiConfig,
  customReducers,
);

const competencyFrameworkSlice = slice;

export default competencyFrameworkSlice.reducer;

export const {
  createCompetencyFrameworkPredefined,
  createCompetencyFramework,
  getCompetencyFramework,
  getPublishedCompetencyFramework,
  getProjectByAccount,
  getArchivedCompetencyFramework,
  getCalibratedArchivedCompetencyFramework,
  getCompetencyFrameworkStatusHistory,
  getAllLevelPublishedCompetencyFramework,
  getCompetencyFrameworkById,
  getCompetencyFrameworkByProjectId,
  getCompetencyFrameworkDetails,
  archiveAndUnarchiveFramework,
  updateCompetencyFramework,
  updateStatusCompetencyFramework,
  forceDeleteCompetencyFramework,

// setup actions
  getCompetencyFrameworkConfig,
  createCompetencyFrameworkConfig,
  updateCompetencyFrameworkConfig,
  deleteCompetencyFrameworkConfig,
  updateCompetencyFrameworkStatusConfig,
  getPublishedCompetencyFrameworkSetup,
  getCompetencyFrameworkDetailsSetup,
  getCompetencyFrameworkStatusHistorySetup

} = thunks;

export const {
  rowSelect,resetMessage,resetErrMessage,
  selectAccountData,
  selectProjectData,
  setCompetencySearchTerm,
  setAllCompetencyFramework,
  setCompetencyFramework
} = actions;

const resetFunction = (dispatch) => {
  timeoutCall(() => {
    dispatch(resetMessage());
    dispatch(resetErrMessage());
  });
};